import React from "react";
import { Modal } from "antd";
import { URButton } from "../../../../shared/widgets/button";
import styles from "../meetingStart/startMeeting.module.scss";
import { toastInformation } from "../../../../base/callService/common";
import { copyTemplate } from "../../../../base/meetingService/utils";
import moment from "moment";
import { Link } from "react-router-dom";


type CopyInvitePopUpProps = {
  detailPage: any;
  invitePropsCalling: Function;
  isCopyModal: boolean;
}

export default function CopyInvitePopUp({detailPage,invitePropsCalling,isCopyModal}:CopyInvitePopUpProps) {
    let replaced_url:any= detailPage.invite_url?.includes("stagemeet") ? detailPage.invite_url : detailPage.invite_url?.replace('meet.unifiedring', 'meet.worktual');
  const handleOk = () => {
    copyTemplate('copyMeeting');
    toastInformation('Meeting invitation copied', 'success');
    invitePropsCalling();
  };

  const handleCancel = () => {
    invitePropsCalling();
  };

  // const downloadIcalendar = () => {
  //   calendarType(detailPage, detailPage.invite_url, "copyinvite");
  // }
  return (
    <>
      <Modal visible={isCopyModal} title="Copy Meeting Invitation"
        className="customPopup meetinvite modaloverwrite"
        centered
      >
        <span className={`icon_close cutomtopclose ${styles.cursorTop}`} onClick={handleCancel} />
        <div className="meetingInviteconsec" id='copyMeeting'>
          {/* <div className="meetingtopheader">
            <h4>Meeting Invitation</h4>
          </div> */}
          <div className="meetinginnerconsec">
            <p className={styles.inviteTitle}><span>{detailPage.hostName}</span>{` is invite
                    you to a Worktual meeting.`} </p>
            <p className="marbtmmin"><span className={styles.titleTxt}>Topic </span><span className={styles.DescTxt}>{detailPage.title}</span></p>
            <p className="marbtmmin"><span className={styles.titleTxt}>Time</span>
              <span className={styles.DescTxt}>
                {/* {timeStampConverter(detailPage.start_timestamp, 'list')}&nbsp; */}
                {moment(detailPage.start_timestamp).format('Do MMMM YYYY hh:mm A ')}
                <br />
               {/* {convertRruleToText(detailPage?.rrule)} <br /> */}
                {/* {convertRruleToDates(detailPage?.rrule)} */}
              </span>
            </p>
            <p className="marbtmmin"><span className={styles.titleTxt}>Duration </span><span className={styles.DescTxt}>{detailPage.duration_minutes+' min'}</span></p>
            {/* <p className="boxheadlink marbtmmin">Please download and import the following
              iCalendar (.ics) files to your calendar system.

              Weekly:<p className="hyperlink" onClick={downloadIcalendar}>{replaced_url}</p></p> */}
            <p className={styles.linkCopy}>
              {/* <span className={styles.DescTxt}>Join Worktual Meeting: </span> */}
              <Link className={styles.hyperlink} to={{ pathname: replaced_url }} target="_blank" >{replaced_url}</Link>
              {/* <span className={styles.svgCopy}>
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M23.6687 8.47334C22.5305 7.39324 20.9587 7.21064 19.4309 7.17454C18.1868 7.14234 17.3059 7.14234 16.0657 7.17454C14.5369 7.21064 12.9651 7.39234 11.8269 8.47334C11.3557 8.92014 11.068 9.46164 10.8863 10.0304C9.84423 10.2277 9.01963 10.6068 8.39083 11.2037C7.14033 12.3902 7.10473 14.2174 7.07883 15.5523L7.07593 18.9644L7.07883 19.1119C7.10473 20.4459 7.14033 22.273 8.39083 23.4693C9.57833 24.5963 11.2233 24.7867 12.8224 24.8248C13.4762 24.8414 14.0343 24.8492 14.5919 24.8492C15.1495 24.8492 15.7081 24.8414 16.36 24.8248C17.9606 24.7867 19.6056 24.5963 20.7931 23.4693C21.4991 22.7999 21.8038 21.9312 21.9478 21.1514C22.5775 20.96 23.1665 20.6648 23.6686 20.188C24.8649 19.0542 24.9005 17.3296 24.924 16.1734V12.4732C24.9006 11.3326 24.865 9.60814 23.6687 8.47334ZM23.4116 12.0627C22.6551 12.0542 22.1089 12.0222 21.6784 11.8981C20.4582 11.5612 19.5373 10.4381 19.4387 9.16184C19.4253 9.00024 19.433 8.83834 19.4354 8.67674C20.8342 8.71214 21.9168 8.87794 22.6364 9.56124C23.2372 10.1315 23.3715 11.058 23.4116 12.0627ZM19.761 22.3815C18.9871 23.1159 17.8279 23.2897 16.3235 23.3249C15.0442 23.3581 14.1423 23.3581 12.8591 23.3249C11.3562 23.2897 10.197 23.1149 9.42553 22.3835C8.62763 21.6208 8.60183 20.2722 8.57883 19.0837L8.57593 15.7312L8.57883 15.5818C8.60173 14.3933 8.62763 13.0466 9.42303 12.2918C9.73203 11.9988 10.1219 11.7884 10.6046 11.6382C10.5811 11.9876 10.574 12.3252 10.568 12.6345L10.5651 15.8796L10.568 16.0202C10.5924 17.2946 10.6261 19.0407 11.8263 20.1882C12.9645 21.2683 14.5363 21.4509 16.0641 21.487C16.6862 21.5026 17.2169 21.5104 17.7477 21.5104C18.278 21.5104 18.8092 21.5026 19.4293 21.487C19.7287 21.4799 20.0293 21.4641 20.3285 21.4401C20.1954 21.8339 20.0117 22.1437 19.761 22.3815ZM22.6365 19.1003C21.909 19.7907 20.8142 19.9538 19.3928 19.987C18.176 20.0173 17.3196 20.0173 16.1008 19.987C14.6809 19.9538 13.5862 19.7907 12.8611 19.1022C12.114 18.3874 12.0896 17.1149 12.0676 15.9918L12.0652 12.8063L12.0676 12.6627C12.0896 11.5406 12.114 10.2682 12.8596 9.56114C13.5862 8.87074 14.6809 8.70764 16.1023 8.67444C16.7107 8.65884 17.2288 8.65104 17.7478 8.65104C17.8001 8.65104 17.8546 8.65204 17.907 8.65224C17.9043 8.86364 17.8964 9.07604 17.9138 9.28384C18.0627 11.2174 19.4123 12.86 21.2629 13.3707C21.8596 13.5428 22.5242 13.5821 23.424 13.5914V16.1578C23.4001 17.3375 23.3216 18.4509 22.6365 19.1003Z" fill="#757676"/>
                </svg>
              </span> */}
            </p>
            <div className=""><span className={styles.meetingTitle}>Meeting ID </span><div className={styles.meetingID}>{detailPage.meeting_id}</div></div>
            {detailPage.is_custom_password && <><div className="marbtmmin"><span className={styles.meetingTitle}>Passcode: </span><span className={styles.meetingID}>{detailPage.password}</span></div></>}
          </div>
        </div>
        <div className={styles.footersection}>
          <URButton className='urButton buttonWhite mr8' onClick={handleCancel} name="Cancel"></URButton>
          <URButton className='urButton buttonBlue' onClick={handleOk} name="Copy Invitation"></URButton>
        </div>
      </Modal>
    </>
  );
};

